import React from 'react'
import PropTypes from 'prop-types'
import { FormControl } from 'react-bootstrap'
import styled from 'styled-components'

const HiddenInput = styled.input`
  position: absolute !important;
  z-index: 3 !important;
  opacity: 0;
`
const inputClass = size => size ? `form-control input-${size}` : 'form-control'

class FileInput extends React.Component {
  constructor(...args) {
    super(...args)
    this.file = null
    this.state = {
      value: '',
    }
  }

  handleChange = e => {
    if (e.target.files.length === 0) {
      this.setState({ value: ''})
      this.props.onChange(null)
    } else {
      this.file = e.target.files[0]
      this.setState({ value: this.file.name })
      this.props.onChange(this.file)
    }
  }

  render() {
    const { accept, placeholder, bsSize, bsStyle } = this.props

    return (
      <div style={{ position: 'relative' }}>
        <HiddenInput type='file' className={inputClass(bsSize)} onChange={this.handleChange} accept={accept}/>
        <FormControl
          type='text'
          bsSize={bsSize}
          bsStyle={bsStyle}
          value={this.state.value}
          placeholder={placeholder}
        />
      </div>

    )
  }
}

FileInput.defaultProps = {
  accept: '*',
  placeholder: '',
  onChange: () => {}
}

FileInput.propTypes = {
  accept: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
}

export default FileInput



// WEBPACK FOOTER //
// ./src/components/widgets/FileInput.js